export default __webpack_public_path__ + "static/media/25092705.a5e9dabf.jpg";